export enum CurrencySignPositionEnum {
  AFTER = "AFTER",
  BEFORE = "BEFORE",
}
export enum CurrencySeparatorEnum {
  POINT = ".",
  COMMA = ",",
}

export type CurrencyResponseType = {
  statusCode: number;
  currencies: CurrencyType[];
};

export type CurrencyType = {
  id: number;
  isoCode: string;
  name: string;
  sign: string;
  signPosition: keyof typeof CurrencySignPositionEnum;
  separator: keyof typeof CurrencySeparatorEnum;
  dateFormat: string;
};

export type CurrencyOptionType = {
  id: string;
  name: string;
};

export type CountryCurrencyType = {
  id: string;
  country: string;
  currencyIso: string;
};

export enum CURRENCIES_ID {
  BDT = 2,
  INR = 3,
  UZS = 4,
  PKR = 6,
  EUR = 7,
  KZT = 11,
  KES = 70,
  MMK = 100,
}

export type NumberSeparators = {
  millionSeparator: string;
  thousandSeparator: string;
  fractionalSeparator: string;
};
